import { render, staticRenderFns } from "./dataCenterDetail.vue?vue&type=template&id=46d0e65a&scoped=true"
import script from "./dataCenterDetail.vue?vue&type=script&lang=js"
export * from "./dataCenterDetail.vue?vue&type=script&lang=js"
import style0 from "./dataCenterDetail.vue?vue&type=style&index=0&id=46d0e65a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d0e65a",
  null
  
)

export default component.exports